import { useRef } from 'react';
import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';

interface PdfPreviewModalProps {
  open: boolean;
  onClose: () => void;
  /** Shown as the dialog title; the document's own title names the PDF. */
  title: string;
  /** A full HTML document from utils/pdfDocument. */
  html: string;
}

/**
 * Print preview of an export document. "Save as PDF" opens the browser's print
 * dialog for this document only (not the app screen); choose "Save as PDF" there.
 */
export default function PdfPreviewModal({ open, onClose, title, html }: PdfPreviewModalProps) {
  const frame = useRef<HTMLIFrameElement>(null);

  const save = () => {
    const view = frame.current?.contentWindow;
    if (!view) return;
    view.focus();
    view.print();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      icon="ri-file-pdf-2-line"
      title={title}
      subtitle='Preview. In the print dialog, choose "Save as PDF" as the destination.'
      widthClassName="max-w-5xl"
      footer={
        <>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button icon="ri-file-pdf-2-line" onClick={save}>
            Save as PDF
          </Button>
        </>
      }
    >
      <iframe
        ref={frame}
        title={`${title} preview`}
        srcDoc={html}
        className="h-[65vh] w-full rounded-md border border-background-200 bg-white"
      />
    </Modal>
  );
}
